import { toThousandFilter } from './format'

const filters = {
  toThousandFilter
}

export default {
  install(Vue) {
    Object.keys(filters).forEach((key) => {
      Vue.filter(key, filters[key])
    })
  }
}



// WEBPACK FOOTER //
// ./src/filters/index.js